import { c as a } from "../../vendor/index-Clj7Qfzb.js";
const t = a(
  "peer inline-flex cursor-pointer items-center rounded-full border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "h-6 w-11 shrink-0 border-2 [&>span]:size-5 [&>span]:shadow-lg [&>span]:data-[state=checked]:translate-x-5",
        material2: "h-[15px] w-[45px] shrink-0 [&>span]:size-[25px] [&>span]:shadow-[0px_1px_9px_0px_rgba(19,25,35,0.2)] [&>span]:data-[state=checked]:translate-x-[21px]"
      },
      color: {
        default: "data-[state=checked]:bg-primary data-[state=unchecked]:bg-switch [&>span]:bg-background",
        blue: "data-[state=checked]:bg-switch-blue-track data-[state=unchecked]:bg-switch [&>span]:data-[state=unchecked]:bg-background [&>span]:data-[state=checked]:bg-switch-blue-thumb"
      }
    },
    defaultVariants: {
      variant: "default",
      color: "default"
    }
  }
);
export {
  t as switchVariants
};
